import React from 'react';
import styled from 'styled-components';

import Checked from 'images/checked.svg';

const Checkbox = props => {
    return(
        <StyledLabel>
            <StyledCheckbox 
                className={props.className}
                inputType="checkbox" 
                name={props.name} 
                onChange={props.onChange}
                checked={props.checked}
            >
            </StyledCheckbox>
            <p>{props.text}</p>
        </StyledLabel>
    )
}

export default Checkbox;

const StyledLabel = styled.label`
    display: flex;
    align-items: center;
`

const StyledCheckbox = styled.input.attrs({
    type: props => props.inputType,
  })`  
    -webkit-appearance: none;
    width: 24px;
    height: 24px;
    border: 1px solid ${props => props.theme.colors.input};
    margin-right: 16px;
    cursor: pointer;
    transition: border .2s ease;
    flex-shrink: 0;

    &:checked {
        background-image: url(${Checked});
        background-repeat: no-repeat;
        background-position: center;
    }

    &:hover,
    &:focus {
        border-color: ${props => props.theme.colors.text};
    }
`